import { EMAIL_HREF } from "../../Data/siteContent";

const LegalContent = ({ data }) => {
  const renderItem = (item, i) => {
    switch (item.type) {
      case "p":
        return <p key={i}>{item.text}</p>;

      case "bold-intro":
        return (
          <p key={i}>
            <strong>{item.text}</strong>
          </p>
        );

      case "bold-p":
        return (
          <p key={i}>
            <strong>{item.bold}</strong>
            {item.text}
          </p>
        );

      case "list":
        return (
          <ul key={i}>
            <li>
              <strong>{item.intro}</strong>
            </li>
            <ul>
              {item.items.map((li, j) => (
                <li key={j}>{li}</li>
              ))}
            </ul>
          </ul>
        );

      case "bullets":
        return (
          <ul key={i}>
            {item.items.map((li, j) =>
              typeof li === "string" ? (
                <li key={j}>{li}</li>
              ) : (
                <li key={j}>
                  <strong>{li.bold}</strong>
                  {li.text}
                </li>
              )
            )}
          </ul>
        );

      case "contact-link":
        return (
          <p key={i}>
            {item.text}
            <a href={EMAIL_HREF} className="email-link">
              {item.linkText || "contact us"}
            </a>
            {"."}
          </p>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <h2>{data.title}</h2>
      <p>{data.intro}</p>
      {data.sections.map((section, i) => (
        <div key={i}>
          <h2>{section.heading}</h2>
          {section.content.map(renderItem)}
        </div>
      ))}
    </>
  );
};

export default LegalContent;
